import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadSystemsSuccess(systems) {
  return { type: types.LOAD_SYSTEMS_SUCCESS, systems };
}

export function createSystemSuccess(system) {
  return { type: types.CREATE_SYSTEM_SUCCESS, system };
}

export function updateSystemSuccess(system) {
  return { type: types.UPDATE_SYSTEM_SUCCESS, system };
}

export function deleteSystemSuccess(system) {
  return { type: types.DELETE_SYSTEM_SUCCESS, system };
}

export function loadSystems() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'systems';
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadSystemsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveSystem(system) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'systems';
    if (system.id) {
      url = baseApi + 'systems/' + system.id;
      return axios
        .put(url, {
          ...system,
        })
        .then((response) => {
          dispatch(updateSystemSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          systemId: system.systemId,
          systemName: system.systemName,
          systemState: system.systemState,
          systemType: system.systemType,
          isActive: system.isActive || true,
        })
        .then((response) => {
          dispatch(createSystemSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteSystem(system) {
  return function (dispatch) {
    let url = baseApi + 'systems/' + system.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteSystemSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/systemActions.js